module.exports = __webpack_public_path__ + "media/assets/fonts/RobotoCondensed-Regular-fc3d2f2e3a203d0037c14fbdadeaaec2.ttf";